import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { useStyles } from "./styles";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FalconRow } from "./FalconRow";
import { TABLE_SIDE_ROWS, TABLE_SIDE_ROWS_THREE } from "./falconTable";
import { DateLabelType, FalconDateData, FalconTableRow } from "types/Falcon";
import { FalconTableHeadCell } from "./FalconTableHeadCell";
import FalconCollapseRow from "./FalconCollapseRow";
import { getFilteredFalconData } from "utils/filters";
import { DateTime } from "luxon";

interface PropsType {}

const FalconBody: FC<PropsType> = () => {
  const classes = useStyles();
  const { userData } = useTypeSelectors((state) => state.auth);
  const { falconFilters, falconData } = useTypeSelectors((state) => state.falconTable);
  const [headColumns, setHeadColumns] = useState<DateLabelType[]>([]);

  useEffect(() => {
    switch (falconFilters?.selectType) {
      case "week":
        if (falconData?.dateList[0]?.day) {
          const weekLabels = falconData?.dateList.map((item: FalconDateData) => ({
            label: item?.day,
            date: item?.date,
          }));
          setHeadColumns(weekLabels);
        }
        break;
      case "month":
        if (falconData?.dateList[0].week_number) {
          const monthLabels = falconData?.dateList.map((item: FalconDateData) => ({
            label: "Week",
            date: item?.week_number,
          }));
          setHeadColumns(monthLabels);
        }
        break;
    }
  }, [falconFilters?.selectType, falconData?.dateList]);

  return (
    <Box className={classes.body}>
      <Box className={classes.filterTextBox}>
        <Typography className={classes.filterText}>
          {Number(falconFilters.station)
            ? userData.station_spots.find(
                (spot) => spot.station.id === Number(falconFilters.station),
              )?.station.title
            : "All Stations"}
          ,{" "}
          {falconFilters.selectType === "week"
            ? `Week ${falconFilters.date.week?.split("-W")[1]} (${falconFilters.date.week?.split("-W")[0]})`
            : `${DateTime.fromFormat(falconFilters.date.month || "", "yyyy-MM").toFormat("MMMM yyyy")}`}
        </Typography>
      </Box>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.tableHeadCell}`} colSpan={2}>
                <Typography
                  className={`${classes.mainLabel} ${classes.tableCellContent} ${classes.borderCellRightDark}`}
                >
                  Route
                </Typography>
              </TableCell>
              <TableCell className={`${classes.tableHeadCell}`} colSpan={2}>
                <Typography
                  className={`${classes.mainLabel} ${classes.tableCellContent} ${classes.borderCellRightDark}`}
                >
                  Size
                </Typography>
              </TableCell>
              <TableCell
                className={`${classes.tableHeadCell} ${classes.borderCellRightDark}`}
                colSpan={2}
              >
                <Typography className={`${classes.mainLabel} ${classes.tableCellContent}`}>
                  Hours
                </Typography>
              </TableCell>
              {headColumns.map((item: DateLabelType) => (
                <FalconTableHeadCell columnData={item} />
              ))}
              <TableCell className={`${classes.tableHeadCell}`} colSpan={2}>
                <Typography className={`${classes.mainLabel} ${classes.tableCellContent}`}>
                  Total
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getFilteredFalconData(TABLE_SIDE_ROWS, falconData)?.map((row: FalconTableRow) => (
              <FalconRow tableRow={row} headColumns={headColumns} />
            ))}
            <FalconCollapseRow headColumns={headColumns} />
            {TABLE_SIDE_ROWS_THREE?.map((row: FalconTableRow) => (
              <FalconRow tableRow={row} headColumns={headColumns} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FalconBody;
